<template>
  <section class="_menu-section-style">
    <form-section label="Galeria de imagens" v-model="isExpanded.gallery">
      <MultipleUploadImage v-model="selectedSection.items" type="thumb" multiple/> 
    </form-section> 

    <form-section label="Título" v-model="isExpanded.title">
      <Texts 
        textType="title" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
        useTextArea
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>

    <form-section label="Texto" v-model="isExpanded.text">
      <Texts 
        textType="text" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection"
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg" :divider="false">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        :minValueForNumber="160"
        @update="onUpdateBackground"
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>    

  </section>
</template>

<script>
import FormSection from '../../_v2/utils/FormSection.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Background from '../forms/formsV2/Background.vue'
import MultipleUploadImage from '../../_v2/utils/MultipleUploadImage.vue'
import isEmpty from './isEmpty.vue'

export default {
  name: 'GallerySection',
  components: { 
    FormSection, 
    Texts, 
    Background, 
    MultipleUploadImage,
    isEmpty
  },  
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  data: () => ({
    isExpanded: {title: true, text: true, bg: true, gallery: true}    
  }),

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    }
  }      
}
</script>